<template>
  <div class="template">
    <Form ref="addForm" :label-width="150">
        <Tabs type="card" v-model="activeName">
            <TabPane v-for="(item,index) in form" :label="item.group" :name="item.group" :key="index">
                <FormItem v-for="(items,i) in item.items" :key="i" :label="items.title" :prop="items.name">
                   <div>
                    <Input clearable
                    v-if="items.type=='string'"
                    v-model="items.content"
                    maxlength="20"
                    :placeholder="items.comment"
                    style="width:300px"
                    ></Input>

                    <i-switch v-if="items.type=='boolean'" true-value="1" false-value="0" v-model="items.content" />
                    <!-- <editor  ref="editor" v-model="FullgiftForm.introduction" editorId="content" @on-change="editChange" /> -->
                    <editor style="width: 700px;" v-if="items.type=='html'"  ref="editor1" v-model="items.content" :editorId="items.name" @on-change="editChange(arguments,index,i,items.name)" />

                     <div class="upload-Img" v-if="items.type=='img'">
                       <div v-if="items.content" class="look-img">
                         <img :src="items.content" style="width: 100%" />
                         <div class="demo-upload-list-cover">
                           <Icon
                               type="ios-eye-outline"
                               @click.native="lookFile(items.content)"
                           ></Icon>
                           <Icon
                               type="ios-trash-outline"
                               @click.native="deletetemplateFile(index,i)"
                           ></Icon>
                         </div>
                       </div>
                       <template v-else>
                         <Upload
                             :action="uploadUrl"
                             :headers="headers"
                             :on-error="uploadErr"
                              :on-success="(value) => uploadSuccess(value,index,i)"
                             v-model="items.content"
                             :show-upload-list="false"
                         >
                           <div class="upload-btn">
                             <Icon
                                 type="ios-cloud-upload"
                                 size="60"
                                 style="color: #3399ff"
                             ></Icon>
                           </div>
                         </Upload>
                       </template>
                     </div>
                  </div>
                  <div>{{items.comment}}</div>
                </FormItem>

            </TabPane>
        </Tabs>

         <Button
        type="primary"
        style="width: 90px;"
        @click="modalConfirm"
        >保存</Button>
    </Form>
  </div>
</template>

<script>
import {
  manageUpdate,
  manageVariables
} from '@/api/system/system-config.js'
import Editor from '_c/editor'
import '@wangeditor/editor/dist/css/style.css'
export default {
  name: 'product-infor',
  components: { Editor },
  data () {
    return {
      headers: {
        token: localStorage.getItem('token')
      },
      uploadUrl: process.env.VUE_APP_API_URL + '/upload-file',
      query: {},
      form: null,
      activeName: ''
    }
  },
  computed: {
  },
  methods: {

    editChange (argument, index, i, name) {
      var res = argument[0]
      var text = argument[1]
      console.log(res, text, index, i, name)
      if (res == '<p><br></p>') {
        this.form[index].items[i].content = res
        return
      }
      this.form[index].items[i].content = res
    },
    // 获取表格数据
    getVariables () {
      this.$store.commit('setSpinShow', true)
      manageVariables().then((res) => {
        this.form = res.data
        this.activeName = res.data[0].group
      }).finally(() => this.$store.commit('setSpinShow', false))
    },
    modalConfirm () {
      var that = this
      var item = []
      this.form.forEach(v => {
        v.items.forEach(value => {
          var list = {
            name: value.name,
            content: value.content
          }
          item.push(list)
        })
      })
      var param = {
        items: item
      }
      this.$refs['addForm'].validate(valid => {
        if (valid) {
          manageUpdate(param).then(res => {
            this.$Message.success('保存成功')
            this.getVariables()
          })
        }
      })
    },
    // 查看文件
    lookFile (url) {
      const a = document.createElement('a')
      document.body.appendChild(a)
      a.target = '_blank'
      a.href = url
      a.click()
      document.body.removeChild(a)
    },
    uploadSuccess (res, index, i) {
      if (res.code != 200) {
        return this.$Modal.error({ title: '提示', content: res.msg })
      }
      this.$Message.success('文件上传成功')
      this.form[index].items[i].content = res.data.fileUrl
    },
    // 文件上传失败
    uploadErr () {
      this.$Spin.hide()
      this.progressStatus = 'wrong'
      this.$Modal.error({
        title: '提示',
        content: '文件上传失败，请重试'
      })
    },
    deletetemplateFile (index, i) {
      this.$Modal.confirm({
        title: '提示',
        content: '确认删除文件？',
        onOk: () => {
          this.form[index].items[i].content = ''
        }
      })
    }

  },
  mounted () {
    this.getVariables()
  },
  beforeDestroy () {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  }
}
</script>

<style scoped lang="less">
.look-img {
        display: flex;
        align-items: center;
        width: 100px;
        height: 100px;
        border: 1px dashed rgba(197, 197, 197, 1);
        text-align: center;
        justify-content: space-evenly;
        position: relative;
        overflow: hidden;
    }

    .demo-upload-list-cover {
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.6);
        text-align: center;
    }

    .look-img:hover .demo-upload-list-cover {
        display: block;
    }

    .demo-upload-list-cover i {
        line-height: 98px;
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }

    .demo-spin-icon-load {
        animation: ani-demo-spin 1s linear infinite;
    }
</style>
